"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAddToSapiCart = void 0;
var _react = require("react");
var _domainServices = require("@site/domain-services");
var _constants = require("../constants");
// TODO: [USIDOM-1465] clean up file to use shared components - Conversation Search should handle this.

const useAddToSapiCart = (params = {}) => {
  const [addToCartData, setAddToCartData] = (0, _react.useState)(null);
  const [status, setStatus] = (0, _react.useState)(_constants.REQUEST_STATUS.INIT);
  const [addToCartParams, setAddToCartParams] = (0, _react.useState)({});
  const addToCart = async ({
    domainName,
    product,
    itc,
    basketId
  }) => {
    try {
      const requestPayload = (0, _domainServices.constructSapiPost)({
        trackingCode: itc,
        products: [{
          name: domainName,
          ...product
        }],
        additionalPackageAttributes: {},
        additionalPostDataAttribute: {}
      });
      const extraParams = {
        domainName
      };
      if (basketId) {
        extraParams.basketId = basketId;
      }
      setStatus(_constants.REQUEST_STATUS.LOADING);
      const result = await (0, _domainServices.sapiPostToCartPromise)(params, extraParams, requestPayload);
      const {
        cartCount,
        message,
        status: resultStatus
      } = result || {};
      if (cartCount > 0) {
        setAddToCartData(result);
        setAddToCartParams(extraParams);
        setStatus(_constants.REQUEST_STATUS.SUCCESS);
        return [result, _constants.REQUEST_STATUS.SUCCESS, null];
      } else if (resultStatus === 422 && message.includes(`Domain ${domainName} is not available`)) {
        setAddToCartData(result);
        setStatus(_constants.REQUEST_STATUS.UNAVAILABLE);
        return [result, _constants.REQUEST_STATUS.UNAVAILABLE, null];
      }
      setStatus(_constants.REQUEST_STATUS.FAIL);
      return [null, _constants.REQUEST_STATUS.FAIL, result?.errors];
    } catch (err) {
      setStatus(_constants.REQUEST_STATUS.FAIL);
      return [null, _constants.REQUEST_STATUS.FAIL, err];
    }
  };
  addToCart.reset = () => {
    setAddToCartData(null);
    setAddToCartParams({});
    setStatus(_constants.REQUEST_STATUS.INIT);
  };
  if (addToCartData && status === _constants.REQUEST_STATUS.SUCCESS) {
    return [addToCart, {
      ...(addToCartData || {}),
      domainName: addToCartParams?.domainName
    }, _constants.REQUEST_STATUS.SUCCESS];
  }
  return [addToCart, null, status];
};
exports.useAddToSapiCart = useAddToSapiCart;